import { render } from "./AccessLevel.vue?vue&type=template&id=ba0945fc"
import script from "./AccessLevel.vue?vue&type=script&lang=js"
export * from "./AccessLevel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/components/AccessLevel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba0945fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba0945fc', __exports__)) {
    api.reload('ba0945fc', __exports__)
  }
  
  module.hot.accept("./AccessLevel.vue?vue&type=template&id=ba0945fc", () => {
    api.rerender('ba0945fc', render)
  })

}


export default __exports__